import { render, staticRenderFns } from "./YoYChart.vue?vue&type=template&id=463ee06a"
import script from "./YoYChart.vue?vue&type=script&lang=js"
export * from "./YoYChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports